/**
 * Calculate width/height (e.g., of an image) based on existing width/height values and rotation.
 * ChatGPT helped w/ this function.
 */
export function calculateDimensionsWithRotation({
  height,
  rotation,
  width,
}: {
  height: number;
  rotation: number;
  width: number;
}): { containerHeight: number; containerWidth: number } {
  // Normalize the rotation value to be within 0 to 360 degrees.
  const normalizedAngle = rotation % 360;
  const radians = (normalizedAngle * Math.PI) / 180;
  const cosAngle = Math.abs(Math.cos(radians));
  const sinAngle = Math.abs(Math.sin(radians));

  return {
    containerHeight: width * sinAngle + height * cosAngle,
    containerWidth: width * cosAngle + height * sinAngle,
  };
}

/**
 * Scale width/height (e.g., of an image) while preserving aspect ratio.
 * Function produced by ChatGPT.
 */
export function scaleDimensionsToFit(args: {
  maxHeight: number;
  maxWidth: number;
  originalHeight: number;
  originalWidth: number;
}): { scaledHeight: number; scaledWidth: number } {
  const { maxHeight, maxWidth, originalHeight, originalWidth } = args;
  // Calculate the scaling factors for width and height independently.
  const widthScalingFactor = maxWidth / originalWidth;
  const heightScalingFactor = maxHeight / originalHeight;

  // Use the smaller scaling factor to ensure the image fits within the constraints.
  const scalingFactor = Math.min(widthScalingFactor, heightScalingFactor);

  return {
    scaledHeight: originalHeight * scalingFactor,
    scaledWidth: originalWidth * scalingFactor,
  };
}
